"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    footerRegion: 'US',
    regions: [
        {
            country: "United States",
            code: 'US',
            language: "English",
            url: "https://www.ff.com/us/"
        },
        {
            country: "China",
            code: 'CN',
            language: "中文",
            url: "https://www.faradayfuturecn.com/cn/"
        }
    ],
    navLinks: [
        {
            links: [
                { text: 'FF 91 Futurist Alliance 2.0', url: '/us/product/ff-91-Alliance/' },
                { text: 'FF 91 Futurist 2.0', url: '/us/product/ff-91-Futurist/' },
                { text: 'FF 91 2.0', url: '/us/preorder/ff-91' },
                { text: 'FF aiHypercar+', url: '/us/ecosystem-product/' },
            ]
        },
        {
            links: [
                { text: 'FF 6x4 aiHypercar Architecture 2.0', url: '/us/aihyper-architecture/' },
                { text: 'All-Ability aiHypercar', url: '/us/all-ability-aihypercar/' },
            ]
        },
        {
            links: [
                { text: 'Live & Event', url: '/us/ff91event/' },
                { text: 'Press Room', url: '/us/press-room/' },
                { text: 'Investor Relations', url: 'https://investors.ff.com/' },
            ]
        },
        {
            links: [
                { text: 'Charging', url: '/us/charging/' },
                { text: 'Service', url: '/us/service/' },
                { text: 'FF Shop', url: 'https://shop.ff.com/' },
                { text: 'Get Updates', url: '/us/find-us/' },
            ]
        },
        {
            links: [
                { text: 'Contact Us', url: '/us/contact-us/' },
                { text: 'Find Us', url: '/us/find-us/' },
                { text: 'My Account', url: '/us/MyFF' },
            ]
        },
    ],
    extraLinks: [
        {
            text: 'Privacy & Legal',
            url: '/us/privacy-policy/'
        },
        {
            text: 'About Us',
            url: '/us/our-company/'
        },
        {
            text: 'Our Team',
            url: '/us/our-team/'
        },
        {
            text: 'Careers',
            url: '/us/careers/'
        },
    ],
    socialLinks: [
        {
            url: "https://www.facebook.com/faradayfuture/",
            icon: "ff-icon-social-facebook"
        },
        {
            url: "https://www.youtube.com/c/faradayfuture",
            icon: "ff-icon-social-youtube"
        },
        {
            url: "https://twitter.com/faradayfuture?lang=en",
            icon: "ff-icon-social-twitter"
        },
        {
            url: "https://www.instagram.com/faradayfuture/",
            icon: "ff-icon-social-instagram"
        },
        {
            url: "https://www.linkedin.com/company/faradayfuture",
            icon: "ff-icon-social-linkedin"
        },
        {
            url: 'https://genesis-cdn.faradayfuturecn.com/WeChat%20QR%20code.jpg',
            icon: 'ff-icon-social-wechat'
        },
    ],
    copyright: {
        text: "Faraday&Future Inc. © {year}",
        link_url: 'https://beian.miit.gov.cn/',
        link_text: '京ICP备19018825号-1',
        icon_url: '',
        show_horizontal_alignment: true,
        moreLinks: [{
                url: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502045145',
                text: '京公网安备 11010502045145号',
                icon_url: 'https://genesis-cdn.ff.com/beian-icon.png',
            }]
    },
};
exports.default = defaultProps;
